/* ONME LABS theme — interactions.
   Device detection lives in device.js and runs before paint. */
(() => {
  const $  = s => document.querySelector(s);
  const $$ = s => Array.from(document.querySelectorAll(s));
  const clamp = (v,a,b) => Math.max(a, Math.min(b,v));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const dev = () => (window.ONME && window.ONME.device) || 'desktop';
  let heavy = dev() !== 'mobile' && !reduce;
  addEventListener('onme:device', () => { heavy = dev() !== 'mobile' && !reduce; });

  const money = c => {
    const f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined,{style:'currency',currency:f}).format(c/100); }
    catch(e){ return '$' + (c/100).toFixed(2); }
  };

  /* ── nav ───────────────────────────────────────────── */
  const nav = $('#nav');
  const onNav = () => nav && nav.classList.toggle('solid', scrollY > 24);
  onNav();

  const mb = $('#menubtn'), menu = $('#menu');
  if (mb && menu) {
    const close = () => { mb.setAttribute('aria-expanded','false'); menu.classList.remove('on'); };
    mb.addEventListener('click', () => {
      const open = mb.getAttribute('aria-expanded') === 'true';
      mb.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('on', !open);
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
    addEventListener('keydown', e => e.key === 'Escape' && close());
    addEventListener('resize', () => innerWidth > 760 && close(), {passive:true});
  }

  /* ── reveals ───────────────────────────────────────── */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold:.16, rootMargin:'0px 0px -7% 0px' });
  $$('.rv').forEach(n => io.observe(n));

  const pio = new IntersectionObserver(es => es.forEach(e =>
    e.target.classList.toggle('in', e.isIntersecting)), { threshold:.42 });
  $$('.panel').forEach(n => pio.observe(n));

  /* ── count-up ──────────────────────────────────────── */
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    cio.unobserve(e.target);
    const node = e.target, target = parseInt(node.dataset.count, 10) || 0;
    if (reduce) { node.firstChild.textContent = target.toLocaleString('en-US'); return; }
    const t0 = performance.now(), dur = 1100;
    const step = t => {
      const p = clamp((t - t0)/dur, 0, 1), eased = 1 - Math.pow(1-p, 3);
      node.firstChild.textContent = Math.round(target*eased).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }), { threshold:.6 });
  $$('[data-count]').forEach(n => cio.observe(n));

  /* ── scroll-linked motion (desktop/tablet only) ────── */
  const shot = $('#heroshot'), pin = $('#pin'), art = $('#pinart'), glow = $('#glow'), sbar = $('#sbar');
  let ticking = false;
  const frame = () => {
    ticking = false;
    onNav();
    if (sbar) sbar.classList.toggle('on', dev() !== 'desktop' && scrollY > 440);
    if (!heavy) return;
    const vh = innerHeight;
    if (shot) {
      const p = clamp(scrollY/(vh*.9), 0, 1);
      shot.style.transform = `translate3d(0,${-p*88}px,0) scale(${1-p*.13})`;
      shot.style.opacity = String(1 - p*.85);
    }
    if (pin && art) {
      const r = pin.getBoundingClientRect(), total = r.height - vh;
      if (total > 0) {
        const p = clamp(-r.top/total, 0, 1);
        art.style.transform = `translate3d(0,${(p-.5)*44}px,0) scale(${.94 + p*.12})`;
      }
    }
    if (glow) {
      const r = glow.parentElement.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        const p = (vh - r.top)/(vh + r.height);
        glow.style.transform = `translate3d(-50%,${p*130}px,0)`;
      }
    }
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, {passive:true});
  addEventListener('resize', frame, {passive:true});
  frame();

  /* ── FAQ ───────────────────────────────────────────── */
  $$('.qa > button').forEach(btn => btn.addEventListener('click', () => {
    const qa = btn.parentElement, ans = qa.querySelector('.ans');
    const open = qa.dataset.open === '1';
    qa.dataset.open = open ? '0' : '1';
    ans.style.maxHeight = open ? 0 : ans.scrollHeight + 'px';
  }));

  /* ── gallery ───────────────────────────────────────── */
  const galImg = $('#galImg'), dots = $('#dots');
  if (dots && galImg) dots.querySelectorAll('button').forEach((b, i) => b.addEventListener('click', () => {
    galImg.src = b.dataset.img;
    dots.querySelectorAll('button').forEach((d, j) => d.setAttribute('aria-current', String(i === j)));
  }));

  /* ── product form: variant + pack + quantity ───────── */
  const form = $('[data-product-form]');
  if (form) {
    const variantInput = $('#variantId'), qtyInput = $('#qtyInput'), qtyVal = $('#qtyVal');
    const packs = $$('#packs .pick'), variants = $$('#variants .pick');
    let unit = 0, compare = 0, qty = 1, packQty = 1, discount = 0;

    const firstVariant = variants.find(v => v.getAttribute('aria-pressed') === 'true') || variants[0];
    if (firstVariant) { unit = +firstVariant.dataset.price; compare = +firstVariant.dataset.compare; }
    else {
      const t = $('#totalNow');
      unit = t ? Math.round(parseFloat(t.textContent.replace(/[^0-9.]/g,'')) * 100) : 0;
    }

    const paint = () => {
      const gross = unit * packQty * qty;
      const net   = Math.round(gross * (1 - discount/100));
      const was   = compare ? compare * packQty * qty : 0;
      if ($('#totalNow')) $('#totalNow').textContent = money(net);
      if ($('#totalWas')) $('#totalWas').textContent = was > net ? money(was) : '';
      if ($('#perDay'))   $('#perDay').textContent =
        discount ? `Save ${discount}% — applied automatically at checkout` : '';
      if ($('#sbPrice'))  $('#sbPrice').textContent = money(net);
      packs.forEach(p => {
        const pq = +p.dataset.qty, pd = +p.dataset.discount;
        const el = p.querySelector('[data-pack-price]');
        if (el) el.innerHTML = money(Math.round(unit*pq*(1-pd/100))) +
          (compare ? `<s>${money(compare*pq)}</s>` : '');
      });
      if (qtyInput) qtyInput.value = packQty * qty;
      if (qtyVal)   qtyVal.textContent = qty;
    };

    variants.forEach(v => v.addEventListener('click', () => {
      if (v.dataset.available === 'false') return;
      variants.forEach(o => o.setAttribute('aria-pressed', String(o === v)));
      variantInput.value = v.dataset.variant;
      unit = +v.dataset.price; compare = +v.dataset.compare;
      const nm = $('#variantName'); if (nm) nm.textContent = v.dataset.title;
      paint();
    }));

    packs.forEach(p => p.addEventListener('click', () => {
      packs.forEach(o => o.setAttribute('aria-pressed', String(o === p)));
      packQty = +p.dataset.qty; discount = +p.dataset.discount;
      paint();
    }));

    const startPack = packs.find(p => p.getAttribute('aria-pressed') === 'true');
    if (startPack) { packQty = +startPack.dataset.qty; discount = +startPack.dataset.discount; }

    $$('[data-qty-step]').forEach(b => b.addEventListener('click', () => {
      qty = clamp(qty + (+b.dataset.qtyStep), 1, 10); paint();
    }));

    $$('[data-submit-form]').forEach(b => b.addEventListener('click', () => form.requestSubmit()));

    // delivery estimate
    const el = $('#deliverBy');
    if (el) {
      const min = +(el.dataset.min || 2), max = +(el.dataset.max || 5);
      const a = new Date(), b = new Date();
      a.setDate(a.getDate()+min); b.setDate(b.getDate()+max);
      const o = { month:'short', day:'numeric' };
      el.textContent = `Get it ${a.toLocaleDateString('en-US',o)} – ${b.toLocaleDateString('en-US',o)}`;
    }

    paint();

    // AJAX add so the drawer opens instead of a page reload
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('#buyBtn'), label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: +variantInput.value, quantity: +qtyInput.value })
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add to bag');
        await refreshCart(); openCart();
      } catch (err) {
        alert(err.message);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      }
    });
  }

  /* ── cart drawer ───────────────────────────────────── */
  const bag = $('#bagEl'), scrim = $('#scrim');
  const openCart  = () => { bag && bag.classList.add('on'); scrim && scrim.classList.add('on'); };
  const closeCart = () => { bag && bag.classList.remove('on'); scrim && scrim.classList.remove('on'); };
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); refreshCart(); openCart(); }));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', closeCart));
  addEventListener('keydown', e => e.key === 'Escape' && closeCart());

  const FREE_AT = (window.ONME_FREE_SHIPPING_CENTS || 4900);

  async function refreshCart() {
    let cart;
    try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; }
    const count = cart.item_count;
    $$('[data-cart-count]').forEach(n => n.textContent = count);
    const sub = $('#subtotal'); if (sub) sub.textContent = money(cart.total_price);
    const co = $('#checkoutBtn'); if (co) co.disabled = count === 0;

    const ship = $('#shipEl');
    if (ship) {
      const need = Math.max(0, FREE_AT - cart.total_price);
      const pct  = Math.min(100, cart.total_price / FREE_AT * 100);
      ship.innerHTML = need > 0
        ? `You're <b>${money(need)}</b> away from free shipping.<span class="trk"><i style="width:${pct}%"></i></span>`
        : `<b>Free shipping unlocked.</b><span class="trk"><i style="width:100%"></i></span>`;
    }

    const lines = $('#lines');
    if (!lines) return;
    if (!count) { lines.innerHTML = '<div class="empty">Your bag is empty.</div>'; return; }
    lines.innerHTML = cart.items.map((it, i) => `
      <div class="li">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt="">
        <div>
          <b>${it.product_title}</b>
          <div class="m">${it.variant_title || ''}</div>
          <div class="m">Qty ${it.quantity}</div>
          <button class="rm" type="button" data-remove="${i+1}">Remove</button>
        </div>
        <div style="font-weight:600;font-size:15px">${money(it.final_line_price)}</div>
      </div>`).join('');
    lines.querySelectorAll('[data-remove]').forEach(b => b.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ line: +b.dataset.remove, quantity: 0 })
      });
      refreshCart();
    }));
  }
  refreshCart();
})();
